import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { tabsScrollStyle, tabsStyle } from './Header.css';
import { useScrollOverflow } from './HeaderTabs.hooks';

type Props = ComponentPropsWithRef<'div'>;

export const HeaderTabs = ({ children, ...delegated }: Props) => {
  const { scrollDataAttributes, scrollRef } = useScrollOverflow();

  return (
    <div {...delegated} {...scrollDataAttributes} className={clsx(tabsStyle, delegated.className)}>
      <div className={tabsScrollStyle} ref={scrollRef}>
        {children}
      </div>
    </div>
  );
};
